// extracted by mini-css-extract-plugin
module.exports = {"dateLogo":"Logo_dateLogo__3zAx1","Logo":"Logo_Logo__1DyWS","logoTitle":"Logo_logoTitle__3-5_G","date":"Logo_date__2-0m3"};